import "./_activity-timeline.scss";

/**
 * The design's Activity panel - a vertical dot-and-line timeline, not a
 * generic "nothing here yet" empty state. Shared by Company/Subscription
 * Activity tabs (both only have one real data point today - the record's
 * own creation - so a single-item timeline is the honest rendering of
 * that, rather than a mismatched empty-state illustration for a fact we
 * do have).
 */
const ActivityTimeline = ({ items = [] }) => (
  <div className="activity-timeline">
    <div className="activity-timeline__surface">
      {items.map((item, idx) => (
        <div className="activity-timeline__item" key={item.label ?? idx}>
          <span className={`activity-timeline__dot activity-timeline__dot--${item.tone || "primary"}`} />
          <div className="activity-timeline__content">
            <p className="activity-timeline__title">{item.label}</p>
            {item.desc && <p className="activity-timeline__desc">{item.desc}</p>}
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default ActivityTimeline;
